<template>
  <div class="app">
    <el-card class="box-card">

        <div class="header">
          <el-row :gutter="24">
            <el-col :span="12">
              <el-popover
                placement="top"
                width="160"
                v-model="delAllStatus"
                style="margin-right: 8px;"
              >
                <p>您確認要刪除嗎？</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="delAllStatus = false">取消</el-button>
                  <el-button type="primary" size="mini" @click="delAll">確定</el-button>
                </div>
                <el-button size="small" type="danger" slot="reference">
                  <i class="fa fa-trash"></i> 批量刪除
                </el-button>
              </el-popover>

              <el-button
                size="small"
                type="info"
                @click="$refs.RoomTable.clearSelection()"
                style="margin-right: 8px;"
              >取消選擇</el-button>

              <el-button
                size="small"
                type="success"
                @click="handleCreate('create')"
                style="margin-right: 8px;"
              ><i class="el-icon-plus" style="font-weight: 900;"></i> 添加用戶組</el-button>

            </el-col>

            <el-col :span="12">
              <el-input placeholder="填寫查詢內容" size="small" v-model="query" class="employees-input">
                <el-button slot="append" @click="queryBin">
                  <i class="fa fa-search"></i>
                </el-button>
              </el-input>
            </el-col>
          </el-row>
        </div>

      <el-row :md="24">
        <el-col :md="10" :lg="15" style="padding-right:10px;">
          <!-- 列表 -->
          <el-table
          ref="RoomTable"
          :data="data.list"
          :height="data.total?clientHeight:'100'"
          v-loading="loading"
          @selection-change="handleSelectionChange"
          border
          style="width: 100%;">
          <el-table-column fixed type="selection" width="40"></el-table-column>
          <el-table-column  prop="id" label="# 編號" width="80"></el-table-column>
          <el-table-column  prop="title" label="用戶組名稱"></el-table-column>
          <el-table-column fixed="right" label="操作">
            <template slot-scope="scope">
              <div style="text-align: center;">
                <el-link type="primary" @click="edit(scope.row)" >編輯</el-link> |
                <el-link type="danger" @click="del(scope.row.id)" :disabled="scope.row.id !=1?false:true">删除</el-link>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="pager">
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :page-size="data.pageSize"
            :total="data.total"
          ></el-pagination>
        </div>
        </el-col>

        <el-col :md="14" :lg="9">
          <el-card class="box-card" shadow="never">
            <div slot="header">
              <span>{{statusTitle}}</span>
            </div>

            <el-form :model="form" :rules="rules" ref="form" label-width="80px">

              <el-form-item label="組名稱" prop="title">
                <el-input v-model="form.title" placeholder="填寫用戶組名稱" :clearable="true" />
              </el-form-item>

              <el-form-item label="規則組" prop="ruleId">
                <el-select v-model="form.ruleId" placeholder="請選擇">
                  <el-option
                    v-for="item in ruleList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="排序" prop="sort">
                  <el-input-number
                    v-model="form.sort"
                    :min="0"
                    :max="255"
                    style="width: 100%;"
                    controls-position="right" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="狀態">
                    <el-switch v-model="form.status" active-value="1" inactive-value="0"></el-switch>
                  </el-form-item>
                </el-col>
              </el-row>


              <el-form-item label="備註" prop="remark">
                <el-input v-model="form.remark" placeholder="備註" type="textarea" :rows="3" />
              </el-form-item>

              <el-button
                type="primary"
                :loading="formLoading"
                size="medium"
                style="float: right; margin-bottom: 12px;"
              @click="createOrUpdate">確定</el-button>
            </el-form>
          </el-card>
        </el-col>
      </el-row>

    </el-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {ApiGetMenuList} from '@/utils/http'
export default {
  computed: {
    ...mapState({
      iconList: (state) => state.icon.list,
    }),
  },
  data() {
    return {
      loading:false,
      delAllStatus: false,
      clientHeight:'600',

      query:'',
      data:{
          list:[],
          pageSize:5,
          total:0,
      },
      page: 1,
      form: {
        id: 0,
        ruleId: 0,
        title: '',
        status: 0,
        sort: 0,
        remark:'',
      },
      formStatus: "create",
      formLoading: false,
      statusTitle: "添加用戶組",




      //iconList:[],

      data: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      menuStatus: "收起",

      isExpandAll: false,
      hackReset: true,
      expanded: [],
      filterText: "",
      treeModule: {},
      treeProps: {
        label: "label",
        children: "children",
      },
      auth: {
        add: false,
        del: false,
        set: false,
        status: false,
        move: false,
      },
      ruleList: [],
      form: {
        id: 0,
        title: '',
        ruleId: '',
        sort: 0,
        remark:'',
      },
      rules: {
        title: [
          {
            required: true,
            message: "名称不能为空",
            trigger: "blur",
          },
          {
            max: 32,
            message: "长度不能大于 32 个字符",
            trigger: "blur",
          },
        ],
        ruleId: [
          {
            required: true,
            message: "请选择规则组",
            trigger: "change",
          }
        ],
        sort: [
          {
            type: "number",
            message: "必须为数字值",
            trigger: "blur",
          },
        ],
        remark: [
          {
            max: 255,
            message: "长度不能大于 255 个字符",
            trigger: "blur",
          },
        ],
      },

    };
  },
  mounted() {
    this.getGroupList()
    this.getRuleList()
  },
  methods: {
    // 获取权限规则列表
    getRuleList(){
      let that = this;
      this.$http.GET(
        "/v1/auth/getRuleListAll",
        function (ret) {
          if (ret.errcode == 0) {
            that.ruleList = ret.data.list || [];
          }
        }
      );
    },
    // 获取用户组列表
    getGroupList(page){
      let that = this;
      let param = that.$atk.json_to_url({
        page: page || parseInt(that.page),
        query: that.query,
        status: "all",
      });
      that.loading = true;
      this.$http.GET(
        "/v1/auth/getGroupList?" + param, (ret)=> {
          that.loading = false;
          if (ret.errcode == 0) {
            that.data = ret.data;
            console.log(that.data)
          } else if (ret.errcode == 1) {
            that.$message({
              message: ret.errmsg,
              type: "warning",
            });
          }
        },(err)=> {
          that.loading = false;
          that.$notify({
            title: "警告",
            message: err,
            type: "warning",
          });
        }
      );
    },
    // 分页
    handleCurrentChange(val) {
      this.page = val;
      this.getGroupList(val);
    },
    // 重置表单
    resetForm() {
      this.form = {
        id: 0,
        ruleId: 0,
        title: '',
        status: 0,
        sort: 0,
        remark:'',
      };
    },
    // 点击树节点事件
    edit(data) {
      this.statusTitle = "編輯用戶組";
      this.resetForm();
      this.resetElements("update");
      this.form = {
        ...data,
        //ruleId: data.ruleId.toString(),
        status: data.status.toString(),
      };
    },
    // 重置元素
    resetElements(val = "create") {
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
      this.formStatus = val;
      this.formLoading = false;
    },
    // 选择用户
    handleSelectionChange(val) {
      this.multipleSelection = val; //.filter(val => val.id!=1)
      let row = val.filter((val) => val.id == 1);
      this.$refs.RoomTable.toggleRowSelection(row[0], false);
    },
    // 删除已选择用户
    delAll() {
      let that = this;
      let length = that.multipleSelection.length;
      if (length <= 0) {
        that.$notify({
          title: "回收提示",
          message: "请勾选回收用户",
          type: "warning",
        });
        that.delAllStatus = false;
        return;
      }
      let ids = [];
      for (let i in that.multipleSelection) {
        ids[i] = that.multipleSelection[i].id;
      }
      that.remove(ids);
      that.delAllStatus = false;
    },
    // 删除
    del(ids){
      let that = this
      this.$confirm("确定要执行该操作吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
      }).then(() => {
          that.remove(ids);
      }).catch(() => {});
    },
    // 查询
    queryBin() {
      let that = this;
      if (!that.query) {
        that.$message({
          message: "请输入查询内容",
          type: "warning",
        });
        return;
      }
      this.getList();
    },
    // 添加/更新菜单
    createOrUpdate() {
      let that = this
      that.$refs.form.validate((valid) => {
        if (valid) {
          that.formLoading = true;
          let form = {
            ...that.form,
            status:parseInt(that.form.status)
          }
          that.$http.POST('/v1/auth/addOrEditUserGroup',form,function (ret) {
              if (ret.errcode == 0) {
                that.$emit("refresh");
                that.getGroupList()
                that.$message.success(ret.errmsg);
                that.formLoading = false;
              } else if (ret.errcode >= 1) {
                that.formLoading = false;
                that.$message({
                  message: ret.errmsg,
                  type: 'warning'
                })
              }
          },(err)=> {
              that.formLoading = false;
              that.$notify({
                title: '警告',
                message: err,
                type: 'warning'
              })
            }
          )
        }
      });
    },
    // 删除列表用户
    deleteItem(item, list) {
      for (let key in this.data.list) {
        if (list[key].id === item) {
          list.splice(key, 1);
        }
      }
    },
    // 删除菜单
    remove(ids) {
      let that = this
      that.$http.DELETE('/v1/auth/delUserGroup?ids='+ids,function (ret) {
          if (ret.errcode == 0) {
            if(ids[0]){
              for (let key in ids) {
                that.deleteItem(ids[key],that.data.list);
              }
            } else{
              that.deleteItem(ids,that.data.list);
            }
            //that.getGroupList()
            that.handleCreate("create");
            that.$message.success(ret.errmsg);
          } else if (ret.errcode >= 1) {
            that.$message({
              message: ret.errmsg,
              type: 'warning'
            })
          }
      },(err)=> {
          that.$notify({
            title: '警告',
            message: err,
            type: 'warning'
          })
        }
      )
    },

    isAdd(uid) {
      let db = this.data;
      let db2 = db;
      let level = 1;
      for (let o in db) {
        if (db[o].id == uid) {
          level = 2;
          if (db[o].parentId) {
            for (let i in db2) {
              if (db2[i].id == db[o].parentId) {
                level = 3;
              }
            }
          }
        }
      }
      return level;
    },
    handleClose(done) {
      done();
    },
    // 禁用/解禁按钮
    isDisableBin(id, state=false){

    },
    // 过滤菜单
    filterNode(value, data) {
      if (!value) {
        return true;
      }
      return data.label.indexOf(value) !== -1;
    },
    // 重置表单
    resetForm() {
      this.form = {
        id: 0,
        parentId: 0,
        appRunState: 0,
        icon: '',
        isApp: 0,
        linkType: '0',
        name: '',
        label: '',
        path: '',
        isNav: '0',
        sort: 0,
        remark:'',
      };
    },
    // 重置元素
    resetElements(val = "create") {
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });

      this.formStatus = val;
      this.formLoading = false;
    },
    // 展开或收起节点
    checkedNodes(isExpand) {
      this.filterText = "";
      this.hackReset = false;
      this.$nextTick(() => {
        this.isExpandAll = isExpand;
        this.hackReset = true;
      });
    },
    // 添加菜单表单初始化
    handleCreate(status) {
      this.statusTitle = "添加用户组";
      this.resetForm();
      this.resetElements(status);
    },
    // 追加菜单
    handleAppend(key) {
      this.handleCreate("create");
      this.$refs.tree.setCurrentKey(key);
      this.form.parentId = key;
    },
    // 点击树节点事件
    handleNodeClick(data) {
      this.statusTitle = "编辑用户组";

      this.resetForm();
      this.resetElements("update");

      this.form = {
        ...data,
        linkType: data.linkType.toString(),
        isNav: data.isNav.toString(),
      };
    },

  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
};
</script>
<style scoped lang="scss">
.box-card {
    /* 头部 */
    .header{
        margin-bottom: 12px;
        /* 查询框 */
        .el-input-group__prepend .el-select {
            width: 90px;
        }
        .employees-input {
            button {
                height: 100%;
                padding: 9px 20px;
                border-radius: 0px 3px 3px 0px;
                color: #fff;
                background-color: #25334e;
            }
            button:hover {
                background-color: #182132;
            }
        }
    }
  .tree-scroll {
    max-height: 615px;
    overflow: auto;
    padding-bottom: 1px;
  }
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
    .brother-showing {
      i {
        width: 13px;
      }
      .iconfont {
        font-size: 10px;
        vertical-align: baseline;
      }
    }
  }
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
    .active {
      button {
        height: 20px;
        padding: 3px 10px;
      }
    }
  }
  .active {
    display: none;
  }
  .action:hover .active {
    display: block;
  }
  .icon-dialog-visible {
    height: 500px;
    .icon-list {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 40px;
      color: #7a7b7e;
      font-size: 16px;
    }
    .icon-list:hover {
      cursor: pointer;
      background: #fff;
      border: 1px solid #ebeef5;
      height: 40px;
      padding: 3px;
      z-index: 2000;
      color: #262627;
      line-height: 1.4;
      text-align: justify;
      font-size: 30px;
      -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      word-break: break-all;
    }
  }
}
</style>
